import { DataContext } from "../../../helper/HelperOne"
import NavBar from "../../nav_bar/Navbar"
import { useState } from "react"
import QuotationChatList from "./QuotationChatList"

const QuotationChat = () => {
    const [searchUi, setSearchUi] = useState(false)
    const [searchData, setSearchData] = useState(null)
    return (
        <DataContext.Provider value={{ searchUi, setSearchUi, searchData, setSearchData }}>
            <NavBar
                childrenPage={<QuotationChatList />}
                menuId={10}
            />
        </DataContext.Provider>
    )
}

export default QuotationChat